import {
  CityInfo,
  SearchForCityInfo,
} from '@cbinsights/cbientityservice/cbientityservice';
import { request } from 'client/modules/common/utils/request';

export const searchForCity = ({
  idCountry,
  idState,
  name,
  idCity,
}: Partial<SearchForCityInfo>): Promise<CityInfo[]> => {
  return request({
    url: '/service/cbientityservice/SearchForCity',
    body: { idCountry, idState, name, idCity },
  }).then((res) => res.body.cityInfo);
};
